/**
 * RecoverCann Order Tracking
 * Shopify's classic customer-account order page does not expose `order.fulfillments`
 * in Liquid (confirmed empirically), so tracking is fetched from the Vercel app's
 * Admin-API-backed endpoint instead and injected client-side.
 */

(function () {
  'use strict';

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function renderHeaderLink(container, fulfillments) {
    const first = fulfillments[0];
    const info = first.trackingInfo[0];
    const company = info.company ? ` (${escapeHtml(info.company)})` : '';

    if (info.url) {
      container.innerHTML = `<a href="${escapeHtml(info.url)}" target="_blank" rel="noopener noreferrer">Track shipment${company}</a>`;
    } else if (info.number) {
      container.textContent = `Tracking: ${info.number}`;
    } else {
      return;
    }

    container.hidden = false;
  }

  function renderDetailSection(sectionEl, valueEl, fulfillments) {
    const parts = [];

    fulfillments.forEach((fulfillment) => {
      fulfillment.trackingInfo.forEach((info) => {
        if (info.company) {
          parts.push(`<p>${escapeHtml(info.company)}</p>`);
        }
        if (info.url && info.number) {
          parts.push(`<p><a class="rc-profile-edit-link" href="${escapeHtml(info.url)}" target="_blank" rel="noopener noreferrer">${escapeHtml(info.number)}</a></p>`);
        } else if (info.number) {
          parts.push(`<p>${escapeHtml(info.number)}</p>`);
        }
      });
    });

    if (!parts.length) return;

    valueEl.innerHTML = parts.join('');
    sectionEl.hidden = false;
  }

  async function loadTracking(header) {
    const orderId = header.dataset.rcOrderId;
    const customerId = header.dataset.rcCustomerId;
    const apiBase = header.dataset.rcApiBase;

    if (!orderId || !customerId || !apiBase) return;

    const headerLink = document.getElementById('rc-order-tracking-header');
    const detailSection = document.getElementById('rc-order-tracking-section');
    const detailValue = document.getElementById('rc-order-tracking-value');

    try {
      const url = `${apiBase}/api/account/order-tracking?orderId=${encodeURIComponent(orderId)}&customerId=${encodeURIComponent(customerId)}`;
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;

      const data = await response.json();
      const fulfillments = Array.isArray(data.fulfillments) ? data.fulfillments : [];
      if (!fulfillments.length) return;

      if (headerLink) renderHeaderLink(headerLink, fulfillments);
      if (detailSection && detailValue) renderDetailSection(detailSection, detailValue, fulfillments);
    } catch (error) {
      console.warn('[RecoverCann Order Tracking] Failed to load tracking:', error);
    }
  }

  function init() {
    const header = document.querySelector('.rc-order-header[data-rc-order-id]');
    if (!header) return;
    loadTracking(header);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
